import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { api } from '../../services/api';
import { EventFilters } from '../../components/admin/EventFilters';
import { EventList } from '../../components/admin/EventList';
import { Pagination } from '../../components/admin/Pagination';

const AllOrders = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 9,
    total: 0,
    totalPages: 0,
  });

  const fetchEvents = async (page = 1, filterParams = {}) => {
    setIsLoading(true);
    setError('');

    try {
      const response = await api.getEvents({
        page,
        limit: pagination.limit,
        ...filterParams,
      });

      setEvents(response.events || []);
      setPagination(response.pagination || {
        page,
        limit: pagination.limit,
        total: 0,
        totalPages: 0,
      });
    } catch (fetchError) {
      console.error('Error fetching events:', fetchError);
      setError(fetchError.message || 'Failed to fetch events');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchEvents(1, newFilters);
  };

  const handleFilterReset = () => {
    setFilters({});
    fetchEvents(1, {});
  };

  const handlePageChange = (page) => {
    fetchEvents(page, filters);
  };

  const handleEventClick = (event) => {
    if (!event?._id) {
      return;
    }

    navigate(`/admin/orders/${event._id}`, { state: { event } });
  };

  return (
    <div className="px-2 pt-2">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FileText className="h-6 w-6 text-[#F4A696]" />
          <div>
            <h1 className="text-2xl font-bold text-[#1B3C5C]">All Orders</h1>
            <p className="text-sm text-gray-600 mt-1">
              Select an event to view its orders
            </p>
          </div>
        </div>
      </div>

      <EventFilters onFilterChange={handleFilterChange} onReset={handleFilterReset} />

      {error && (
        <div className="mb-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <EventList
        events={events}
        loading={isLoading}
        onCardClick={handleEventClick}
        onViewOrders={handleEventClick}
        showMenu={false}
      />

      <Pagination
        currentPage={pagination.page}
        totalPages={pagination.totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default AllOrders;
